// interval between the stop and go words
export const STOP_OR_GO_INTERVAL = 1;

export const ONE_BACK_INTERVAL = 1;

export const SENTENCE_TIME_BETWEEN_WORDS = 0.5;
export const SENTENCE_TIME_SHOWING_WORDS = 0.65;

export const FACIAL_RECOGNITION_INTERVAL = 1.5;
